module.exports = __webpack_public_path__ + "img/hand-back-point-right.809ed510.svg";